export {
  FontStyle,
  FontType,
  FontWeight,
  TextAlign,
  TextComponent,
  TextSize,
  TextTransform,
} from './text.component';

export { FontColor, HighlightColor, ReadMore } from './text.model';
